import { render } from "./App.vue?vue&type=template&id=de182252"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=de182252&lang=scss"

import exportComponent from "F:\\gitLab项目\\自主选课\\public-login\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__